
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';
import { ProfileAPIService } from '@/profile/services/api';
import { PinValidation, ConfirmValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { Alert } from '@/core/types/alert';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';
import { CoreHelper } from '@/core/helper';

const EDIT_PIN_SUCCESS_MESSAGE = 'Pin Successfully Updated';

@Component({
	validations: {
		oldPin: PinValidation.validations(4),
		pin: PinValidation.validations(4),
		pinConfirmation: ConfirmValidation.validations('pin'),
	},
})
export default class ProfileEditPinModal extends Vue {
	public alert: Alert | null = null;

	public isLoading = false;

	public isShown = false;

	public oldPin = '';

	public pin = '';

	public pinConfirmation = '';

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	public wasChangeSuccessful = false;

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}

	get oldPinErrors(): string[] {
		return PinValidation.errors(this, 'oldPin', 4);
	}

	get pinConfirmationErrors(): string[] {
		return ConfirmValidation.errors(this, 'pinConfirmation', 'pin');
	}

	get pinErrors(): string[] {
		return PinValidation.errors(this, 'pin', 4);
	}

	public async changePin(): Promise<void> {
		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}

		this.isLoading = true;

		try {
			const { success } = await ProfileAPIService.changePin(this.oldPin, this.pin, this.pinConfirmation);

			this.wasChangeSuccessful = success;

			this.alert = this.wasChangeSuccessful
				? {
					type: AlertTypeEnum.SUCCESS,
					message: EDIT_PIN_SUCCESS_MESSAGE,
				}
				: {
					type: AlertTypeEnum.ERROR,
					message: CoreHelper.getHttpErrorMessage(),
				};
		} catch (error) {
			console.error(error);

			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: CoreHelper.getHttpErrorMessage(error),
			};
		}

		this.isLoading = false;
	}

	public close(): void {
		this.isShown = false;
		this.reset();
	}

	private reset(): void {
		this.alert = null;
		this.isLoading = false;
		this.oldPin = '';
		this.pin = '';
		this.pinConfirmation = '';
		this.wasChangeSuccessful = false;
		this.$v.$reset();
	}
}
